module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "Product"
  }, [_c('div', {
    staticClass: "Product-Image"
  }, [_c('a', {
    attrs: {
      "href": '#/product/' + _vm.moduleId + '/' + _vm.product.product_id
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.picture,
      "alt": _vm.product.name
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Product-Caption"
  }, [_c('p', [_c('span', {
    staticClass: "Product-Price",
    class: {
      'Product-Price--Disabled': _vm.product.is_disabled
    }
  }, [_vm._v("\n                    " + _vm._s(_vm._f("formatCurrency")(_vm.price, _vm.currency)) + "\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "Product-Name"
  }, [_vm._v(_vm._s(_vm.product.name))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-463c780c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/list/_partials/type3.vue
// module id = 256
// module chunks = 1